<template>
  <div class="settings-wrapper">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="settings-container">
      <div class="user-info">
        <div class="user-info-grid">
          <div class="user-info-item">
            <div class="user-info-label">{{ $t('message.settingsPage.userInfo.fullName') }}</div>
            <div class="user-info-value user-info-full-name">{{ userFullName }}</div>
          </div>
          <div class="user-info-item">
            <div class="user-info-label">{{ $t('message.settingsPage.userInfo.birthDate') }}</div>
            <div class="user-info-value">{{ userBirthDate }}</div>
          </div>
        </div>
        <div class="user-info-grid">
          <div class="user-info-item">
            <div class="user-info-label">{{ $t('message.settingsPage.userInfo.phoneNumber') }}</div>
            <div class="user-info-value">{{ userPhone  }}</div>
          </div>
          <div class="user-info-item">
            <div class="user-info-label">{{ $t('message.settingsPage.userInfo.passportSeriesNumber') }}</div>
            <div class="user-info-value">{{ userPassport }}</div>
          </div>
        </div>
        <div class="user-info-item">
          <div class="user-info-label">{{ $t('message.settingsPage.userInfo.registrationAddress') }}</div>
          <div class="user-info-value">{{ userAddress }}</div>
        </div>
      </div>
      <div class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-title">{{ $t('message.settingsPage.changePassword.title') }}</div>
          <div class="settings-card-description">{{ $t('message.settingsPage.changePassword.description') }}</div>
        </div>
        <div class="settings-card-action">
          <base-button
            :text="$t('message.settingsPage.changePassword.btn')"
            :min-height="'38px'"
            @click="$router.push({ name: 'change-password' })"
          />
        </div>
      </div>
      <div class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-title">{{ $t('message.settingsPage.changeContactInfo.title') }}</div>
          <div class="settings-card-description">{{ $t('message.settingsPage.changeContactInfo.description') }}</div>
        </div>
        <div class="settings-card-action">
          <base-button
            :text="$t('message.settingsPage.changeContactInfo.btn')"
            :min-height="'38px'"
            @click="$router.push({ name: 'change-contact-info' })"
          />
        </div>
      </div>
      <div class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-title">{{ $t('message.settingsPage.changeWorkInfo.title') }}</div>
          <div class="settings-card-description">{{ $t('message.settingsPage.changeWorkInfo.description') }}</div>
        </div>
        <div class="settings-card-action">
          <base-button
            :text="$t('message.settingsPage.changeWorkInfo.btn')"
            :min-height="'38px'"
            @click="$router.push({ name: 'change-work-info' })"
          />
        </div>
      </div>
      <div class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-title">{{ $t('message.settingsPage.changePersonalDataAgreement.title') }}</div>
          <div class="settings-card-description">{{ $t('message.settingsPage.changePersonalDataAgreement.description') }}</div>
        </div>
        <div class="settings-card-action">
          <base-button
            :text="$t('message.settingsPage.changePersonalDataAgreement.btn')"
            :min-height="'38px'"
            @click="$router.push({ name: 'change-personal-data-agreement' })"
          />
        </div>
      </div>
      <div class="settings-card">
        <div class="settings-card-content">
          <div class="settings-card-title">{{ $t('message.settingsPage.actualizeDataViaMsi.title') }}</div>
          <div class="settings-card-description">{{ $t('message.settingsPage.actualizeDataViaMsi.description') }}</div>
        </div>
        <div class="settings-card-action">
          <base-button
            :text="$t('message.settingsPage.actualizeDataViaMsi.btn')"
            :min-height="'38px'"
            @click="openActualizeMsiModal()"
          />
        </div>
      </div>
    </div>
    <actual-msi-info-modal
      v-if="isActualizeMsiModalVisible"
      @close="closeActualizeMsiModal()"
    />
  </div>
</template>

<script>
import BaseButton from '../../components/base/BaseButton.vue';
import ActualMsiInfoModal from './actualMsiInfo/actualMsiInfoModal.vue';
import { mapGetters } from 'vuex';
import { formatCompactDate } from '../../helpers/date';

export default {
  name: 'Settings',
  components: {
    BaseButton,
    ActualMsiInfoModal
  },
  created() {
    this.closeActualizeMsiModal();
  },
  data() {
    return {
      isActualizeMsiModalVisible: false
    };
  },
  computed: {
    ...mapGetters(['profile']),
    userFullName() {
      const nameRu = this.profile?.name_ru || {};

      return [nameRu.family_name_ru, nameRu.given_name_ru, nameRu.middle_name_ru]
        .filter(Boolean)
        .join(' ');
    },
    userBirthDate() {
      return formatCompactDate(this.profile?.birthdate);
    },
    userPhone() {
      return this.profile?.contact?.phoneSMSVerification || '';
    },
    userPassport() {
      return this.profile?.id_document?.seriesNumber || '';
    },
    userAddress() {
      return this.profile?.address_str || '';
    }
  },
  methods: {
    openActualizeMsiModal() {
      this.isActualizeMsiModalVisible = true;
    },
    closeActualizeMsiModal() {
      this.isActualizeMsiModalVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.settings-wrapper {
  @include page-wrapper-with-header-and-footer;

  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.settings-container {
  @include base-page-container;

  display: flex;
  flex-direction: column;
  gap: 24px;
}

.user-info {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #ececee;
  border-radius: 8px;
  margin-top: 20px;
}

.user-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.user-info-item {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-info-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #7a7a7a;
}

.user-info-value {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #01273b;
  word-break: break-word;
}

.user-info-full-name {
  text-transform: uppercase;
}

.settings-card {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fbfbfb;
  border-radius: 8px;
}

.settings-card-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #01273b;
}

.settings-card-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}

.settings-card-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}

.settings-card-action {
  flex-shrink: 0;
  width: 192px;
  height: 38px;
}

.settings-card-action ::v-deep .button {
  width: 100%;
  max-height: 38px;
  min-height: 38px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
}

.route-name {
  @include route-name;

  width: 95%;
  text-align: start;
  margin-bottom: 0;
  margin-top: -20px;
}

@media screen and (max-width: 700px) {
  .user-info-grid {
    grid-template-columns: 1fr;
  }

  .settings-card {
    flex-direction: column;
    align-items: stretch;
  }

  .settings-card-action {
    width: 100%;
  }
}
</style>
